<template>
    <div class="Power_report-container">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'请选择'">
            <div class="tree-wrap">
                <me-tree
                    ref="myTree"
                    :treeData="data"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'tree_unit_id'"
                    :showCheckbox="true"
                    :title="'请选择'"
                    :checkStrictly.sync="checkStrictly"
                    :isCheckClick="true"
                    :showStretch="false"
                    nodeKeyName="tree_unit_name"
                    :defaultCheckKeys="defaultCheckKeys"
                    :defaultExpandedKeys="defaultCheckKeys"
                    @handleCheckBoxClick="handleTreeNodeClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="leader-tab power-tab right_container" :style="{ width: width }">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <!-- <el-tab-pane label="实时负荷" name="port"></el-tab-pane> -->
                <el-tab-pane label="日报" name="day"></el-tab-pane>
                <el-tab-pane label="月报" name="month"></el-tab-pane>
                <el-tab-pane label="年报" name="year"></el-tab-pane>
            </el-tabs>
            <div class="table_with_container" v-loading="tableLoading">
                <div class="search_cont">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        class="leader-style-form leader-form-inner-tab-inline"
                    >
                        <el-form-item label="时间" style="float: left">
                            <el-date-picker
                                v-model="time"
                                align="right"
                                type="date"
                                :clearable="false"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                @change="handleTimeChange"
                                v-show="tabVal === 'day' || tabVal === 'port'"
                            ></el-date-picker>
                            <el-date-picker
                                v-model="time"
                                type="month"
                                :clearable="false"
                                placeholder="选择月"
                                value-format="yyyy-MM"
                                :picker-options="pickerOptions"
                                @change="handleTimeChange"
                                v-show="tabVal === 'month'"
                            ></el-date-picker>
                            <el-date-picker
                                v-model="time"
                                type="year"
                                placeholder="选择年"
                                format="yyyy"
                                value-format="yyyy"
                                :clearable="false"
                                :picker-options="pickerOptions"
                                @change="handleTimeChange"
                                v-show="tabVal === 'year'"
                            ></el-date-picker>
                            <!-- <el-button
                                size="small"
                                @click="forwardTimeClick"
                                style="margin-left: 10px"
                            >
                                上一{{
                                    tabVal === "day"
                                        ? "日"
                                        : tabVal === "month"
                                        ? "月"
                                        : "年"
                                }}
                            </el-button>
                            <el-button
                                size="small"
                                :disabled="nextTimeDisabled"
                                @click="nextTimeClick"
                            >
                                下一{{
                                    tabVal === "day"
                                        ? "日"
                                        : tabVal === "month"
                                        ? "月"
                                        : "年"
                                }}
                            </el-button>-->
                        </el-form-item>
                        <!-- <div>
                            <el-button
                                type="primary"
                                size="small"
                                @click="handleSearchReport"
                                >查询</el-button
                            >
                        </div>-->
                        <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
                        <div class="table_with_timetag">
                            <el-tag
                                v-for="tag in timeTags"
                                :key="tag"
                                :closable="canClose"
                                @close="handleRemoveTime(tag)"
                                :disable-transitions="true"
                            >{{ tag }}</el-tag>
                        </div>
                        <!-- </el-scrollbar> -->
                    </el-form>
                </div>
                <div class="table_cont-wrap">
                    <div class="title_style" style="margin: 0 0 20px 0">
                        {{
                            tabVal === "port"
                                ? "实时负荷(单位:kW)"
                                : tabVal === "day"
                                    ? "日报(单位:kW)"
                                    : tabVal === "month"
                                        ? "月报(单位:kW)"
                                        : "年报(单位:kW)"
                        }}
                    </div>
                    <div class="table-wrap-n">
                        <v-chart
                            :auto-resize="true"
                            :options="lineBar"
                            ref="lineBar"
                            theme="ovilia-green"
                            id="lineChart"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import { getTreeUnitList } from "@/http/express/unit-express.js";
import { departmentColor } from "@/utils/chart-color.js";
// import moment from "moment";
import dayjs from "dayjs";
import * as api from "@/http/api.js";
import utils from "@/utils/utils.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        }
    },
    data() {
        return {
            tabVal: "day",
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "tree_unit_name"
            },
            defaultCheckKeys: [],
            pointName: "",
            nodeKey: "tree_unit_id",
            systemDate: {},
            width: "calc(100% - 370px)",
            checkStrictly: true,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            time: "",
            checkStrictly: true,
            nextTimeDisabled: false,
            tableData: [],
            tableHData: [],
            tableLoading: false,
            tableHLoading: false,
            xAxis: [],
            yAxis: [],
            xHAxis: [],
            yHAxis: [],
            todayY: "",
            todayM: "",
            todayD: "",
            sum_active_power: "",
            systemDate: "",
            timeTags: []
        };
    },
    created() {
        // this.getUnitPointList();
        this.getSysDate("day");
        this.todayY = this.getTimeValue("year");
        this.todayM = this.getTimeValue("month");
        this.todayD = this.getTimeValue("day");
        this.nextTimeDisabled = true;
    },
    methods: {
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.handleSearchReport();
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            getTreeUnitList().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    // this.defaultCheckKeys = [
                    //     formatData.firstPoint.tree_unit_id,
                    // ];
                    // this.defaultCheckKeys = [
                    //     res.bus_json.length > 0 &&
                    //     res.bus_json[0].tree_unit_id
                    // ];
                    this.defaultCheckKeys = res.bus_json.length > 0 ? [res.bus_json[0].tree_unit_id] : []
                    // this.defaultCheckKeys = ['1343798748832960512', '1343798934577713152', '1343799177750876160', '1343799534782615552', '1343799942162780160', '1343800232031129600'];
                    this.handleSearchReport();
                    // this.$nextTick(() => {
                    //     this.$refs.myTree.$refs.tree.setCurrentKey(
                    //         formatData.firstPoint.tree_unit_id
                    //     );
                    // });
                    this.tabVal = "day";
                }
                this.treeLoading = false;
            });
        },
        //日期添加
        handleAddTime() {
            if (
                !(
                    this.timeTags.length &&
                    this.timeTags.includes(this.formatShowDay(), 0)
                )
            ) {
                this.timeTags.push(this.formatShowDay());
                return true;
            } else {
                return false;
            }
        },
        //日期删除
        handleRemoveTime(tag) {
            this.tagLoading = true;
            this.timeTags.splice(this.timeTags.indexOf(tag), 1);
            this.handleSearchReport();
        },
        /**
         * 日月年tab切换回调事件
         */
        handleTabClick(tab, event) {
            this.nextTimeDisabled = true;
            if (tab.name === "port") {
                this.time = this.systemDate.sysdate;
                this.tabVal = "port";
            } else if (tab.name === "day") {
                this.time = this.systemDate.sysdate;
                this.tabVal = "day";
            } else if (tab.name === "month") {
                this.time = this.systemDate.sysdate3;
                this.tabVal = "month";
            } else {
                this.time = this.systemDate.sysdate4;
                this.tabVal = "year";
            }
            this.timeTags = [];
            if (this.handleAddTime()) this.handleSearchReport();
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
        },
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate2().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                    this.getUnitPointList();
                    //初始化时把当前日期加到标签里
                    this.handleAddTime();
                }
            });
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            //初始化时把当前日期加到标签里
            if (this.handleAddTime()) this.handleSearchReport();
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day" || this.tabVal === "port") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === "port") {
                this.getIncomeLinePs();
            } else if (this.tabVal === "day") {
                this.getDayData();
            } else if (this.tabVal === "month") {
                this.getMonthData();
            } else {
                this.getYearData();
            }
        },
        getIncomeLinePs() {
            this.tableLoading = true;
            api.getIncomeLinePs({
                ids: this.defaultCheckKeys,
                show_day: this.timeTags
            }).then(res => {
                this.tableLoading = false;
                this.xAxis = res.bus_json.timeList;
                this.yAxis = [];
                if (res.bus_json.dataList && res.bus_json.dataList.length) {
                    res.bus_json.dataList.forEach(item => {
                        this.yAxis.push({
                            name: item.point_name,
                            type: "line",
                            data: item.pList,
                            smooth: true,
                            symbol: "none"
                        });
                        // item.name = this.pointName;
                    });
                }
            });
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            params = {
                ids: this.defaultCheckKeys,
                show_day: this.timeTags
            };
            this.tableLoading = true;
            api.getPowerDayData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = res.bus_json.timeList;
                    this.yAxis = [];
                    const colors = [
                        "#1dabbc",
                        "#fec029",
                        "#ff6e6e",
                        "#3ef5a3",
                        "#5fd4fe",
                        "ffe375",
                        "#d979e4",
                        "#66a228",
                        "#f2783d",
                        "#336699",
                        "#003399",
                        "#a27f59",
                        "#8c8c8c",
                        "#4e2f52"
                    ];
                    if (
                        res.bus_json.powerReportList &&
                        res.bus_json.powerReportList.length
                    ) {
                        res.bus_json.powerReportList.forEach((item, index) => {
                            let data = [];
                            item.data &&
                                item.data.forEach(itemD => {
                                    data.push(itemD.active_power);
                                });
                            this.yAxis.push({
                                name: item.point_name,
                                type: "line",
                                itemStyle: {
                                    color: colors[index]
                                },
                                smooth: true,
                                symbol: "none",
                                data: data
                            });
                            // item.name = this.pointName;
                        });
                    }
                    //this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            this.tableLoading = true;
            params = {
                ids: this.defaultCheckKeys,
                show_day: this.timeTags
            };
            api.getPowerMonthData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = res.bus_json.timeList;
                    this.yAxis = [];
                    const colors = [
                        "#1dabbc",
                        "#fec029",
                        "#ff6e6e",
                        "#3ef5a3",
                        "#5fd4fe",
                        "ffe375",
                        "#d979e4",
                        "#66a228",
                        "#f2783d",
                        "#336699",
                        "#003399",
                        "#a27f59",
                        "#8c8c8c",
                        "#4e2f52"
                    ];
                    if (
                        res.bus_json.powerReportList &&
                        res.bus_json.powerReportList.length
                    ) {
                        res.bus_json.powerReportList.forEach((item, index) => {
                            let data = [];
                            item.data &&
                                item.data.forEach(itemD => {
                                    data.push(itemD.active_power);
                                });
                            this.yAxis.push({
                                name: item.point_name,
                                type: "line",
                                itemStyle: {
                                    color: colors[index]
                                },
                                smooth: true,
                                symbol: "none",
                                data: data
                            });
                            // item.name = this.pointName;
                        });
                    }
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            this.tableLoading = true;
            params = {
                ids: this.defaultCheckKeys,
                show_day: this.timeTags
            };
            api.getPowerYearData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = res.bus_json.timeList;
                    this.yAxis = [];
                    const colors = [
                        "#1dabbc",
                        "#fec029",
                        "#ff6e6e",
                        "#3ef5a3",
                        "#5fd4fe",
                        "ffe375",
                        "#d979e4",
                        "#66a228",
                        "#f2783d",
                        "#336699",
                        "#003399",
                        "#a27f59",
                        "#8c8c8c",
                        "#4e2f52"
                    ];
                    if (
                        res.bus_json.powerReportList &&
                        res.bus_json.powerReportList.length
                    ) {
                        res.bus_json.powerReportList.forEach((item, index) => {
                            let data = [];
                            item.data &&
                                item.data.forEach(itemD => {
                                    data.push(itemD.active_power);
                                });
                            this.yAxis.push({
                                name: item.point_name,
                                type: "line",
                                itemStyle: {
                                    color: colors[index]
                                },
                                smooth: true,
                                symbol: "none",
                                data: data
                            });
                            // item.name = this.pointName;
                        });
                    }
                }
                this.tableLoading = false;
            });
        },
        formatShowDay() {
            let show_day = "";
            if (this.tabVal === "day" || this.tabVal === "port") {
                show_day = dayjs(new Date(this.time)).format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                show_day = dayjs(new Date(this.time)).format("YYYY-MM");
            } else {
                show_day = dayjs(new Date(this.time)).format("YYYY");
            }
            return show_day;
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                firstPoint = obj;
                // if (obj.state === '1') {
                //     //实采集点
                //     obj.disabled = true;
                //     resultArr.push(obj.id);
                // } else if (obj.state === '0') {
                //     //虚点
                //     if (!firstPoint.tree_unit_id) {
                //         firstPoint = obj;
                //     }
                // }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        /**
         * 下一日、下一月、下一年点击
         */
        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day" || this.tabVal === "port") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                ((this.tabVal === "day" || this.tabVal === "port") &&
                    selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        }
    },
    computed: {
        canClose() {
            return this.timeTags.length > 1;
        },
        lineBar() {
            const options = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "line",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    },
                    confine: true,
                    padding: [5, 30, 5, 30],
                    enterable: true
                    // position: function(point, e, dom, rect, size) {
                    //     let chartId = 'lineChart';
                    //     let paddingScreenLeft = document.getElementById('#'+ chartId).offset.left;
                    //     let paddingScreenTop = document.getElementById('#'+ chartId).offset.top;
                    //     document.getElementById(dom).css("position", fixed);
                    //     document.getElementById(dom).html('<div>' + formatter + '</div>');
                    //     return [point[0] + paddingScreenLeft + 5, point[1] + paddingScreenTop];
                    // }
                    // position: [10, 10]
                },
                //    color: departmentColor,
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "10%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: [
                    {
                        name:
                            this.tabVal == "day"
                                ? "时"
                                : this.tabVal == "month"
                                    ? "日"
                                    : "月",
                        type: "category",
                        boundaryGap: false,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        data: this.xAxis
                    }
                ],
                yAxis: [
                    {
                        name: "kW",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: "solid",
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.yAxis
                // series: [
                //     {
                //         type: "line",
                //         //  stack: "总量",
                //         label: {
                //             normal: {
                //                 show: false,
                //                 position: "top",
                //             },
                //         },
                //         itemStyle: {
                //             color: "rgb(86, 252, 255,0.9)",
                //         },
                //         data: this.yAxis,
                //     },
                // ],
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.el-tabs__item {
    color: #fff;
}
.el-tabs--card {
    margin: 0;
}
.Power_report-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    // .active-table {
    //     background: #ff7455 !important;
    //     color: #fff !important;
    //     border-color: #ff7455 !important;
    // }
    // .active-table-data {
    //     background: #083472 !important;
    //     color: #56fcff !important;
    //     border-color: #083472 !important;
    // }
    // .tree-wrap {
    //     width: 280px;
    //     // height: 100%;
    //     padding-bottom: 70px;
    //     box-sizing: border-box;
    //     overflow: hidden;
    //     box-sizing: border-box;
    //     border-radius: 5px;
    // }
    .tree-wrap {
        height: 100%;
        // overflow: hidden;
        height: calc(100% - 10px);
        box-sizing: border-box;
    }
    .right_container {
        height: 100%;
        // // margin-top: 5px;
        // margin: 0 30px 0 0;
        // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        // border-radius: 5px;
        // box-sizing: border-box;
        // transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }
    }
}
// .is-top .is-active {
//     /*color: #56fcff !important;*/
// }
.power-tab {
    margin: 4px 0 0 0;
}
.table_with_container {
    height: calc(100% - 55px);
    .search_cont {
        width: 100%;
        margin: 15px 0 20px 0;
        .form {
            display: flex;
            justify-content: space-between;
            .button-group {
                display: inline-block;
                margin-left: 20px;
                // button {
                //     background: rgb(41, 184, 94);
                //     color: white;
                //     outline: none;
                //     border-color: rgb(41, 184, 94);
                // }
                .el-button.is-disabled,
                .el-button.is-disabled:focus,
                .el-button.is-disabled:hover {
                    border-color: #ebeef5;
                }
            }
            // .el-input__inner {
            //     height: 36px;
            //     line-height: 36px;
            // }
        }
    }
    .table_with_timetag {
        flex: 1;
        overflow-x: auto;
        border-spacing: 5px;
        // >span {
        //     margin-left: 5px;
        // }
        .el-tag {
            margin-left: 5px;
            /*color: #56fcff;*/
            /*background-color: #083472;*/
            /*border-color: #56fcff;*/
            display: table-cell !important;
        }
        .el-tag .el-tag__close {
            /*color: #56fcff;*/
        }
    }
    .table_cont-wrap {
        width: 100%;
        height: calc(100% - 55px - 46px - 35px);
        padding: 0;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .title_style {
            color: #fff;
        }
        .green {
            height: 12px;
            width: 5px;
            background: #0089f1;
            margin: 10px;
            float: left;
        }
        .table_change_btn {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
        width: 100%;
        font-size: 16px;
        text-align: left;
        line-height: 32px;
    }
    .table-wrap-n {
        width: 100%;
        height: calc(100% - 62px);
        // overflow: auto;
        // font-size: 14px;
        font-size: 14px;
        width: 100%;
        padding: 30px 30px 0 30px;
        box-sizing: border-box;
        // height: 500px;
        margin: 0;
        position: relative;
        /*background: url("../../../../assets/image/leaderpage/table-bg.png")*/
        /*    no-repeat;*/
        background-size: 100% 100%;
        overflow: auto;
        .echarts {
            width: 100%;
            height: 100%;
        }
        .table-header {
            width: 100%;
            display: flex;
            flex-direction: row;

            color: #fff;
            height: 50px;
            line-height: 50px;
            // border-top: 1px solid #ededed;
            // border-left: 1px solid #ededee;
        }
        .table-name {
            min-width: 200px !important;
            box-sizing: border-box;
        }
        .table-header-colum {
            flex: 1;
            // border-right: 1px solid #ededed;
            // border-bottom: 1px solid #ededed;
            // background: #f8f8f8;
            background: rgba(38, 77, 132, 0.6) !important;
            text-align: center;
            min-width: 80px;
            padding: 3px 0;
        }
        .table-row {
            display: flex;
            flex-direction: row;
            min-width: 100%;
            color: #fff;

            // border-left: 1px solid #ededee;
            .table-row-item {
                flex: 1;
                // border-right: 1px solid #ededed;
                // border-bottom: 1px solid #ededed;
                text-align: center;
                min-width: 80px;
                // padding: 3.5px 0;
            }
        }
        .table-row:nth-child(2n) .table-row-item {
            background: transparent !important;
            color: #ffffff;
            height: 50px;
            line-height: 50px;
        }

        .table-row:nth-child(2n + 1) .table-row-item {
            background: rgba(38, 77, 132, 0.6) !important;
            color: #ffffff;
            height: 50px;
            line-height: 50px;
        }
        .table-nodata {
            // border: 1px solid #ededed;
            text-align: center;
            // color: #999;
            color: #fff;
        }
    }
}
</style>
